import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'components/Loading';
import EquippedItem from '../EquippedItem';

import EmptySlot from './EmptySlot';
import { IQuality } from 'types/qualities';

export default function EquippedSlotComponent(props: Props) {
  const {
    isChanging,
    quality,
    name,
  } = props;

  // If we're in mid-change, just display a loading icon
  if (isChanging) {
    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
        }}
      >
        <Loading spinner small />
      </div>
    );
  }

  if (quality) {
    return (
      <EquippedItem name={name} {...quality} />
    );
  }

  return <EmptySlot isChanging={isChanging} />;
}

interface Props {
  isChanging: boolean,
  quality?: IQuality,
  name: string,
}

EquippedSlotComponent.propTypes = {
  isChanging: PropTypes.bool.isRequired,
  quality: PropTypes.shape({}),
  name: PropTypes.string.isRequired,
};

EquippedSlotComponent.defaultProps = {
  quality: undefined,
};